import React from 'react';
import { ExternalLink } from 'lucide-react';
import { APR_PRODUCTS, aprUrl, matchAprProducts } from '../../data/aprProducts';

// Linked + priced APR product cards (images scraped from the APR store).
// Pass `productKeys` for an explicit set, or `matchText` to auto-pick relevant ones.
export function AprProductGrid({ productKeys, matchText, limit = 4, title = 'Research-Grade Peptides', subtitle }) {
  const keys = (productKeys && productKeys.length ? productKeys : matchAprProducts(matchText, limit))
    .filter((k) => APR_PRODUCTS[k]);
  if (!keys.length) return null;

  return (
    <section className="my-12" data-testid="apr-product-grid">
      <div className="flex items-end justify-between mb-1">
        <h3 className="font-heading text-xl uppercase tracking-wider text-white">{title}</h3>
        <span className="text-[10px] uppercase tracking-widest text-[#22c55e]">Discount auto-applied</span>
      </div>
      <p className="text-xs text-zinc-500 mb-5">
        {subtitle || 'Third-party tested, made in the USA by American Peptide Research. Our link applies your discount automatically.'}
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {keys.map((slug) => {
          const p = APR_PRODUCTS[slug];
          return (
            <a
              key={slug}
              href={aprUrl(slug)}
              target="_blank"
              rel="noopener sponsored"
              data-apr-product={slug}
              data-apr-name={p.name}
              className="group bg-zinc-900 border border-zinc-800 hover:border-[#22c55e]/60 transition-colors duration-300 p-3 flex flex-col"
              data-testid={`apr-product-card-${slug}`}
            >
              <div className="bg-white rounded overflow-hidden mb-3">
                <img
                  src={`/apr/${slug}.webp`}
                  alt={`${p.name} research peptide vial from American Peptide Research`}
                  width="700"
                  height="467"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto aspect-[3/2] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <span className="text-[10px] uppercase tracking-widest text-zinc-500">{p.label}</span>
              <span className="text-sm font-semibold text-white mt-0.5">{p.name}</span>
              <div className="mt-auto pt-2 flex items-center justify-between">
                <span className="text-[#22c55e] font-bold">${p.price}</span>
                <span className="text-[10px] text-zinc-400 flex items-center gap-1 group-hover:text-[#22c55e] transition-colors">
                  Shop APR <ExternalLink className="w-3 h-3" />
                </span>
              </div>
            </a>
          );
        })}
      </div>
      <p className="text-[10px] text-zinc-600 mt-3">
        Affiliate links. For research use only — not for human consumption.
      </p>
    </section>
  );
}

export default AprProductGrid;
